import { ROUTES } from "@/app/routes";
import { StockListPage } from "@/components/common/StockListPage";
import { useProductStocks } from "@/features/product-stocks/hooks/useProductStocks";

export default function ProductStocksPage() {
  const { stocks, isLoading, error, refresh } = useProductStocks();

  return (
    <StockListPage
      title="Stock marchand"
      subtitle="Ce que vous pouvez vendre aujourd’hui"
      basePath={ROUTES.productStocks}
      stocks={stocks}
      isLoading={isLoading}
      error={error}
      onRetry={() => refresh()}
      emptyHint="Un stock de produits doit être créé avant de pouvoir produire."
      kind="Prêt à vendre"
    />
  );
}
